// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subcategories-modal-content{width:600px !important;height:600px}.subcategories-modal-content .subcategories-modal .lx-grid{height:390px !important}@media(max-width: 767.98px){.subcategories-modal-content{max-width:100% !important}}", ""]);
// Exports
module.exports = exports;
